import { Avatar, Box, Divider, Stack, SxProps } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { burgerMenuItemsPersonalDetailsAndUpdatesSlicer } from 'Config';
import { useAppSelector } from 'Hooks';
import { NoImageAvatar, SideBurgerHome } from 'Images';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuItemTooltip } from './MenuItemTooltip';
import { useState } from 'react';
import { LawyerDialog } from 'Components/LayerDialog';
import { useIsLawyer } from 'Hooks/useIsLawyer';

interface IShrinkBurgerMenuView {
  setExpandedMenuItem: Function;
}
export const ShrinkBurgerMenuView = ({
  setExpandedMenuItem,
}: IShrinkBurgerMenuView) => {
  const [showDialog, setShowDialog] = useState(false);

  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );

  const { pathname } = useLocation();

  const isLawyer = useIsLawyer();

  const boxImageWrapper: SxProps = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    padding: '16px 0',
    '&:hover': {
      cursor: 'pointer',
      bgcolor: 'primary.shade_500',
    },
  };
  const imageStyle: SxProps = { width: '25px', height: '23px' };

  const navigate = useNavigate();

  return (
    <Stack
      direction='column'
      aria-expanded={false}
      sx={{
        alignItems: 'center',
        pt: '32px',
      }}
    >
      <Avatar
        alt=''
        src={NoImageAvatar}
        sx={{ width: '44px', height: '44px' }}
      />
      <Divider
        aria-hidden='true'
        orientation='horizontal'
        sx={{ width: '100%', mt: '12px' }}
      />
      {!isLawyer && (
        <Stack
          direction='column'
          sx={{
            alignItems: 'center',
            mb: '42px',
          }}
        >
          {burgerMenuItems &&
            burgerMenuItems
              .slice(0, burgerMenuItemsPersonalDetailsAndUpdatesSlicer)
              .map((menuItem: IBurgerMenuItem, index: number) => {
                return (
                  <MenuItemTooltip
                    key={index}
                    menuItem={menuItem}
                    setExpandedMenuItem={setExpandedMenuItem}
                    showDialog={() => setShowDialog(true)}
                  />
                );
              })}
        </Stack>
      )}
      <Stack
        direction='column'
        sx={{
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            ...boxImageWrapper,
            bgcolor: pathname === '/' ? 'primary.shade_500' : undefined,
          }}
          onClick={() => {
            if (isLawyer) navigate('/lawyers-lobby');
          }}
        >
          <Avatar alt='' src={SideBurgerHome} sx={{ ...imageStyle }} />
        </Box>
        {burgerMenuItems &&
          burgerMenuItems
            .slice(
              isLawyer ? 0 : burgerMenuItemsPersonalDetailsAndUpdatesSlicer,
              burgerMenuItems.length
            )
            .map((menuItem: IBurgerMenuItem, index: number) => {
              return (
                <MenuItemTooltip
                  key={index}
                  menuItem={menuItem}
                  setExpandedMenuItem={setExpandedMenuItem}
                  showDialog={() => setShowDialog(true)}
                />
              );
            })}
      </Stack>
      {isLawyer && (
        <LawyerDialog showDialog={showDialog} setShowDialog={setShowDialog} />
      )}
    </Stack>
  );
};
